import React from 'react';

const LazyScheduleBlueprintSessionComponent = React.lazy(
  () => import('./ScheduleBlueprintSession')
);

export const LazyScheduleBlueprintSession: React.FC<
  React.ComponentProps<typeof LazyScheduleBlueprintSessionComponent>
> = (props) => {
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <LazyScheduleBlueprintSessionComponent {...props} />
    </React.Suspense>
  );
};
